import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import './NFTCard.css';

const NFTCard = ({ data }) => {
    const [nftImage, setNftImage] = useState(null);
    const [nftName, setNftName] = useState(null);
    const [profileData, setProfileData] = useState(null);

    useEffect(() => {
        if (data?.ipfsHash.length) {
            axios
                .get(data.ipfsHash)
                .then((res) => {
                    let imageSrc;
                    const prefix = res.data.image.split('//')[0];
                    if (prefix === 'ipfs:') {
                        imageSrc = `https://ipfs.io/ipfs/${res.data.image.split('//')[1]}`;
                    } else {
                        imageSrc = res.data.image;
                    }
                    setNftImage(imageSrc);
                    if (res.data.name) {
                        setNftName(res.data.name);
                    }
                })
                .catch((error) => console.error(error));
        }

        axiosInstance
            .get(`${endpoints.getProfileById}?userId=${data.userId}`)
            .then((res) => {
                setProfileData(res.data.result);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [data]);
    return (
        <div className="nft__item explore-nft-item">
            <div className="author_list_pp nft-item-profile">
                <div className="profile-logo">
                    {profileData?.profilePic && <img className="lazy" src={profileData?.profilePic} alt="" />}
                    <i className="fa fa-check"></i>
                </div>
            </div>
            <div className="nft__item_wrap">
                <Link to={`/item-details/${data.contractAddress}/${data.tokenId}`}>
                    <img src={nftImage} className="lazy nft__item_preview" alt="" />
                </Link>
            </div>
            <div className="nft__item_info nft-info-bottom">
                <Link to={`/item-details/${data.contractAddress}/${data.tokenId}`}>
                    <div className="nft__head">{nftName ? <h4>{nftName}</h4> : <h4>99 NFT</h4>}</div>
                    <h4>#{data?.tokenId}</h4>
                </Link>
                <div className="nft__item_price">
                    {data?.nftPrice} ETH
                    {/* <span>1/20</span> */}
                </div>
                {/* {data?.putOnSell && (
                    <div className="nft__item_action">
                        <Link to="/">Buy now</Link>
                    </div>
                )} */}
                {/* <div className="nft__item_like">
                    <i className="fa fa-heart"></i>
                    <span>50</span>
                </div> */}
            </div>
        </div>
    );
};

export default NFTCard;
